
import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGOUT_USER,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAILED,
    FORGET_PASSWORD,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAILED,
    UPDATE_USER_DATA,
    INIT_USER_FROM_COOKIES,
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

export const loginUser = (email, password) => {
    return {
        type: LOGIN_USER,
        payload: { email, password },
    };
};

export const loginUserSuccess = (response) => {
    return {
        type: LOGIN_USER_SUCCESS,
        payload: response,
    };
};

export const loginUserFailed = (error) => {
    return {
        type: LOGIN_USER_FAILED,
        payload: error,
    };
};

export const registerUser = (user) => {
    return {
        type: REGISTER_USER,
        payload: user,
    };
};

export const registerUserSuccess = (response) => {
    return {
        type: REGISTER_USER_SUCCESS,
        payload: response,
    };
};

export const registerUserFailed = (error) => {
    return {
        type: REGISTER_USER_FAILED,
        payload: error,
    };
};

export const logoutUser = (navigate) => {
    return {
        type: LOGOUT_USER,
        payload: { navigate },
    };
};

export const forgetPassword = (forgetUser) => {
    return {
        type: FORGET_PASSWORD,
        payload: forgetUser,
    };
};

export const forgetPasswordSuccess = (response) => {
    return {
        type: FORGET_PASSWORD_SUCCESS,
        payload: response,
    };
};

export const forgetPasswordFailed = (error) => {
    return {
        type: FORGET_PASSWORD_FAILED,
        payload: error,
    };
};

export const updateUserData = (user) => {
    return {
        type: UPDATE_USER_DATA,
        payload: user,
    };
};

export const initUserFromCookies = () => {
    const user = getLoggedInUser();
    return {
        type: INIT_USER_FROM_COOKIES,
        payload: user,
    };
};
